<template>
  <div>
    <div class="form-row border-b-0">
      <template v-if="isInPilotGroup">
        <SplitNameFormPart v-on="$listeners" />
      </template>
      <template v-else>
        <NameField
          :label="$t('field.name.label')"
          placeholder=""
          v-on="$listeners"
        />
      </template>
    </div>

    <AddressFormGroup v-on="$listeners" />

    <div class="form-row border-t-0">
      <PhoneField
        :label="$t('field.phone.label')"
        placeholder=""
        v-on="$listeners"
      />
    </div>

    <div class="form-row">
      <EmailField
        :label="$t('field.email.label')"
        placeholder=""
        v-on="$listeners"
      />
    </div>
  </div>
</template>

<script>
import NameField from 'chimera/all/components/form/fields/name/NameField'
import EmailField from 'chimera/all/components/form/fields/email/EmailField'
import PhoneField from 'chimera/all/components/form/fields/phone/PhoneField'
import AddressFormGroup from 'chimera/all/themes/blueflow/components/form/part/address/AddressFormGroup'
import SplitNameFormPart from 'chimera/all/components/form/parts/SplitNameFormPart.vue'

export default {
  name: 'ContactInformationFormPart',

  components: {
    SplitNameFormPart,
    NameField,
    EmailField,
    PhoneField,
    AddressFormGroup,
  },

  /**
   * @returns {object}
   */
  data() {
    return {
      isInPilotGroup: undefined,
    }
  },

  /**
   */
  beforeMount() {
    // Fallback: check if the concept is in pilot labels
    const labels = [
      'aircovergelijker.nl',
      'alleverhuizers.nl',
      'comparateurdefenetres.be',
      'comparateurdepanneauxsolaires.be',
      'comparateurdepompesachaleur.be',
      'cv-installateurvergelijker.nl',
      'dakkapellenvergelijker.nl',
      'isolatievergelijker.nl',
      'jouw-thuisbatterij.nl',
      'jouw-badkamerspecialist.nl',
      'jouw-keukenspecialist.nl',
      'kozijnenvergelijker.nl',
      'ramenvergelijker.be',
      'warmtepompenvergelijker.nl',
      'zonweringvergelijker.nl',
      'zonnepanelenvergelijker.be',
      'zonnepanelenvergelijker.nl',
    ]

    this.isInPilotGroup = labels.includes(
      process.env.concept?.toLowerCase() || '',
    )
  },
}
</script>
